/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `automobile` - Autoturisme și microbuze ≤8 locuri
 * * `truck_light` - Camioane ≤3500 kg
 * * `truck_heavy` - Camioane >3500 kg
 * * `bus` - Autobuze și microbuze >20 locuri
 * * `trailer` - Remorci și semiremorci
 * * `tractor` - Tractoare și tehnică agricolă
 * * `motorcycle` - Motociclete
 */
export enum CascoCategoryEnum {
  AUTOMOBILE = 'automobile',
  TRUCK_LIGHT = 'truck_light',
  TRUCK_HEAVY = 'truck_heavy',
  BUS = 'bus',
  TRAILER = 'trailer',
  TRACTOR = 'tractor',
  MOTORCYCLE = 'motorcycle',
}
